/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ matched: NonNullable<unknown>, ambiguous: NonNullable<unknown>, unmatched: NonNullable<unknown>, linked: NonNullable<unknown> }} Pm_Counts_LineInputs */

const cs_pm_counts_line = /** @type {(inputs: Pm_Counts_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`✓${i?.matched} · ?${i?.ambiguous} · ✕${i?.unmatched} · ↔${i?.linked}`)
};

const en_pm_counts_line = /** @type {(inputs: Pm_Counts_LineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`✓${i?.matched} · ?${i?.ambiguous} · ✕${i?.unmatched} · ↔${i?.linked}`)
};

/**
* | output |
* | --- |
* | "✓{matched} · ?{ambiguous} · ✕{unmatched} · ↔{linked}" |
*
* @param {Pm_Counts_LineInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pm_counts_line = /** @type {((inputs: Pm_Counts_LineInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pm_Counts_LineInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pm_counts_line(inputs)
	return cs_pm_counts_line(inputs)
});